import { instance } from './instance';

export interface KitchenStaffCoverageAlertConfig {
  enabled: boolean;
  enabledAt: string | null;
}

const unwrap = (data: any): KitchenStaffCoverageAlertConfig =>
  data.data ?? data;

export const platformSettingsApi = {
  getKitchenStaffCoverageAlerts:
    async (): Promise<KitchenStaffCoverageAlertConfig> => {
      const { data } = await instance.get(
        '/admin/kitchen-staff-coverage-alerts'
      );

      return unwrap(data);
    },

  setKitchenStaffCoverageAlerts: async (
    enabled: boolean
  ): Promise<KitchenStaffCoverageAlertConfig> => {
    const { data } = await instance.patch(
      '/admin/kitchen-staff-coverage-alerts',
      {
        enabled,
      }
    );

    return unwrap(data);
  },
};
